import { FuneralHome } from "./FuneralHome";

export interface AccountingEntity {
  COSTCODE: string;
  COMPANY_ID: string;
  FUNERALHOMES: FuneralHome[];
}

// Helper function to generate a unique ID for an accounting entity
export const getAccountingEntityId = (entity: AccountingEntity): string => {
  return `${entity.COMPANY_ID}-${entity.COSTCODE}`;
};

// Helper function to get display name for an accounting entity
export const getAccountingEntityDisplayName = (entity: AccountingEntity): string => {
  const funeralHomeNames = entity.FUNERALHOMES.map(fh => fh.NAME).join(", ");
  return `${funeralHomeNames} (${entity.COSTCODE})`;
};
